// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/de'
import VueLazyload from 'vue-lazyload'
import VueScrollTo from 'vue-scrollto'
// import VueAnalytics from 'vue-analytics'
import VModal from 'vue-js-modal'
import VueCarousel from 'vue-carousel'

Vue.config.productionTip = false

Vue.use(ElementUI, {locale})
Vue.use(VueScrollTo)
Vue.use(VueLazyload)
Vue.use(VueCarousel)
// Vue.use(VueAnalytics, {
//   id: 'UA-148213759-1',
//   router,
//   beforeFirstHit () {
//     Vue.$ga.set('anonymizeIp', true)
//   }
// })
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js